import React, { useEffect } from 'react';

export const DrawerContext = React.createContext({
    open: false,
    setOpen: () => {},
    handleDrawerOpenClose: () => {},
    handleBlockHoverOpen: () => {},
    block: false,
});

const PROJECT_SETTINGS_KEY = 'project-settings';

export const DrawerContextProvider = ({ children }) => {
    const getProjectSettings = () => {
        const settings = localStorage.getItem(PROJECT_SETTINGS_KEY);
        return settings ? JSON.parse(settings) : { openBar: false };
    };

    const [block, setBlock] = React.useState(() => getProjectSettings().openBar);
    const [open, setOpen] = React.useState(() => getProjectSettings().openBar);

    useEffect(() => {
        localStorage.setItem(PROJECT_SETTINGS_KEY, JSON.stringify({ openBar: block }));
    }, [block]);

    useEffect(() => {
        if (block) {
            setOpen(true);
        }
    }, [block]);

    const handleDrawerOpenClose = (state) => {
        if (block) return;
        setOpen(state);
    };

    const handleBlockHoverOpen = () => {
        const newBlockState = !block;
        setBlock(newBlockState);
        setOpen(newBlockState);
    };

    const context = { open, handleDrawerOpenClose, setOpen, handleBlockHoverOpen, block };

    return <DrawerContext.Provider value={context}>{children}</DrawerContext.Provider>;
};
